import mapMinutes from "./mapMinutes";
import range from "./range";

const mapHourRange = (minuteStep) =>
  range(0, 24)
    .map((hourValue) => {
      const minutes = mapMinutes(minuteStep);

      return minutes.map(({ value: minuteValue }) => {
        const value = `${`0${hourValue}`.substr(-2)}:${minuteValue}`;

        return {
          value,
          label: value
        };
      });
    })
    .flat();

export default mapHourRange;
